import { render, staticRenderFns } from "./outdate.vue?vue&type=template&id=c0d3fd54&scoped=true&"
var script = {}
import style0 from "./outdate.vue?vue&type=style&index=0&id=c0d3fd54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d3fd54",
  null
  
)

export default component.exports